

import React from 'react';
import ZProps from './zprops';
import AMC from './AMC';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faStar } from '@fortawesome/free-solid-svg-icons'

export default class ZooStarButton extends React.Component {
	constructor(props) {
		super(props);
		let { item } = this.props;
		this.state = { selected: (ZProps.get(item.uri + ".history_with_thing") || {}).star };
	}
	onClick() {
		let { item } = this.props;
		let { selected } = this.state;
		AMC.relate(item.uri, "star", (err, stats) => {
			item.stars = Math.max(0, (item.stars || 0) + (selected ? -1 : 1));
			this.setState({ selected: !selected });
		});
	}
//        			<svg className="HScoreButtonIcon" viewBox="0 0 14 16" width="14" height="16" aria-hidden="true"><path fillRule="evenodd" d="M14 6l-4.9-.64L7 1 4.9 5.36 0 6l3.6 3.26L2.67 14 7 11.67 11.33 14l-.93-4.74L14 6z"></path></svg>
	render() {
		let { item } = this.props;
		let { selected } = this.state;
		return (
			<div className={"HScoreButton" + (selected ? " BUTTON_SELECTED_COLOR" : "")} onClick={this.onClick.bind(this)}>
			<div className="HScoreButtonLabel" aria-label="Star this thing" title={"Star " + item.name}>
				<FontAwesomeIcon icon={faStar} />
				Star
			</div>
			<div className="HScoreButtonCount" aria-label={item.stars + " users starred this app"}>{item.stars || 0}</div>
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/ZooStarsButton.js